import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SimpleLocaleService {
  private currentLocaleSubject = new BehaviorSubject<string>('en');
  public currentLocale$ = this.currentLocaleSubject.asObservable();

  constructor(private router: Router) {
    // Initialize with current pathname
    this.updateLocaleFromPathname();

    // Listen to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateLocaleFromPathname();
    });

    // Also listen to popstate events for browser back/forward
    window.addEventListener('popstate', () => {
      this.updateLocaleFromPathname();
    });
  }

  private updateLocaleFromPathname(): void {
    const pathname = window.location.pathname;

    // Extract language from pathname like /ja/ or /pt/
    const match = pathname.match(/^\/(pt|ja|en)(\/|$)/);
    console.log('🔍 Pathname match:', match);

    if (match) {
      const detectedLocale = match[1];

      this.currentLocaleSubject.next(detectedLocale);
    } else {
      this.currentLocaleSubject.next('en');
    }
  }

  public getCurrentLocale(): string {
    return this.currentLocaleSubject.value;
  }
}
